import { render, staticRenderFns } from "./GlowTagProductSelect.vue?vue&type=template&id=2f1f02c6&scoped=true&"
import script from "./GlowTagProductSelect.vue?vue&type=script&lang=js&"
export * from "./GlowTagProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./GlowTagProductSelect.vue?vue&type=style&index=0&id=2f1f02c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f02c6",
  null
  
)

export default component.exports